module.exports = __webpack_public_path__ + "img/company.3d4130f1.png";